import React, { Component, PureComponent } from 'react';
import Footer from '../components/footer-bar.component';
import OrderHistory from './order-history';
import OrderCart from './order-cart';
import MenuPage from './menu';
import NoticePage from './notice-page';
import CallWaiter from './call-waiter';
import HomePage from './home-page';
import { States } from '../redux/type';
import { ReduxConnect } from '../decorators/redux-connect.decorator';
import Floating from '../components/floating-window.component';
import '../resources/css/floating.css';
import '../resources/css/public.css';
import Store from '../redux/store';
import ShoppingCart from '../modules/shopping-cart';
import { WebsocketClient } from '../websocket/module';
import { CreateOrderRequestSuccessedEventObject, CreateOrderRequestFailedEventObject, CartCommitEventObject, CustomerIdEventObject, CreateDishEventObject, DishModifyEventObject } from '../websocket/type';
import { MenuDish, OrderInfo, TableStatus, TurnInfo } from '../constants/type.constant';
import { MinimizeCondiment } from '../modules/cart/type';
import { createHashHistory } from 'history';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { DefaultRequest } from '../requests/default.request';
import { MessengerModule } from "../messenger/module";
import { EventEmitter } from 'events';
import { getSettingInfo } from '../tools/get-setting-info';
import _ from 'lodash';
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
import { getCacheField } from '../tools/get-cache-field';
import DisableDish from '../components/disable-dish-moment.component';
import { addCookie } from '../tools/cookie-code';
import { Checkbox, Button, Drawer, Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import EncryptModal from '../components/encrypt-modal.component';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { ConnectCart, CartError, InitCart, Marketing, UpdateCart, SubmitCart, ExcessTip, WSClientEventName } from '../websocket/cart2';
import { CART_MODULE_ERRORS } from '../modules/cart2/error';
import { Cart2 } from '../modules/cart2/type';
import { GMapGetcurrentLocation } from '../constants/tool-googlemap';
import moment from 'moment-timezone';
import { getSeverAndLoacalDiff } from '../tools/local-moment';
import serverShoppingCart from '../modules/server-shopping-cart';

let time: NodeJS.Timeout;
@ReduxConnect((defaultState: States, ownProps: Props) => {
    return {
        // 底部导航栏模式
        foodBarMode: defaultState.foodBarMode,
        // 审核状态
        approvalStatus: defaultState.approvalStatus,
        // 倒计时
        resendOrderSecond: defaultState.resendOrderSecond,
        // 订单信息
        orderTab: defaultState.orderTab
    };
})
class Main extends PureComponent<Props, State> {
    [x: string]: any;
    public messengerModule: MessengerModule;
    public distributionIdEmitter!: EventEmitter;
    // show item_name1 or item_name2
    public isShowName1 = true;
    public count = 0;
    // 3s后自动关闭营销提示倒计时
    public closeAddedTipsTimeout: NodeJS.Timeout | null = null;
    // 正在初始化购物车
    public isInitCart = false;
    // 获取缓存中的扫码时间
    public qrCodeDate: string | null = getCacheField('qrCodeDate');
    // 获取基础设置中的扫码时间间隔 - 默认 4 小时
    public qrCodeTimeDiff: number = getSettingInfo('time_interval', 'value') || 4;
    // 历史记录页面 ref
    public orderHistoryRef: any = null;
    // 重渲染历史记录页面 timer
    public reRenderOrderHistoryTimer: any = null;
    // 点餐菜单页面 ref
    public menuPageRef: any = null;
    // 倒计时悬浮窗口 ref
    floatingWinsRef: any = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            // 加入菜品时的提示状态
            addedTips: false,
            // 勾选提示框是否显示
            isTipsChecked: false,
            // 当前加入到购物车的 item_name
            dishesName: '',
            // 所有顾客的购物车
            cartData: [],
            // 已点数量
            turnCount: 0,
            // 是否开启自主点餐模式
            autonomous: {
                status: true
            },
            // 轮次规则限制是否开启
            globalLimitEnable: true,
            // 轮次规则
            turnInfo: getCacheField('turnInfo'),
            // 开桌审核状态
            isApproved: false,
            // 新手引导显示状态2
            guidehideCardStatus: false,
            // 是否开启临时密码
            isOpenPIN: 0,
            // 禁止点餐（不在餐厅区域）
            disabledOrderBtn: false,
            // 是否开启购物车抽屉
            isOpenCartDrawer: false,
            // 展示超额菜品提示
            isShowDishExcessDialog: false
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    };
    // *********************
    // 生命周期
    // *********************
    public async UNSAFE_componentWillMount() {
        // 校验扫码时间
        if (!this.qrCodeDate) {
            this.messengerModule.say({
                message: `请重新扫码`,
                level: "Error",
            });
            createHashHistory().push({ pathname: '/' });
            return;
        }
        else {
            const timeDiff = moment(new Date()).diff(Number(getCacheField('qrCodeDate')), 'hours');
            if (timeDiff >= this.qrCodeTimeDiff) {
                this.messengerModule.say({
                    message: `请重新扫码`,
                    level: "Error",
                });
                createHashHistory().push({ pathname: '/' });
                return;
            }
        }
        // 获取服务器与本地时间戳差值
        const diffTimeStamp = await getSeverAndLoacalDiff();
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'diffTimeStamp',
            value: diffTimeStamp,
        })
        // *********************
        // 服务端购物车
        // *********************
        // $ 监听WS连接
        WebsocketClient.addListener('CONNECT', this.connectWS);
        // $ 监听WS断开连接
        WebsocketClient.addListener('DISCONNECT', this.disConnectWS);
        // $ 监听连接购物车
        WebsocketClient.addListener('CONNECT_CART', this.connectCartListener);
        // $ 监听初始化购物车
        WebsocketClient.addListener('INIT_CART', this.initCartListener);
        // $ 监听错误提示
        WebsocketClient.addListener('CART_ERROR', this.cartErrorListener);
        // $ 监听校验营销规则
        WebsocketClient.addListener('MARKETING', this.marketingListener);
        // $ 监听购物车正在提交
        WebsocketClient.addListener('SUBMITING_CART', this.submitngCartListener);
        // $ 提交购物车
        WebsocketClient.addListener('SUBMIT_CART', this.submitListener);
        // $ 转台通知
        WebsocketClient.addListener('CHANGE_CART_TABLE', this.changeCartTableListener);

        // $ 审核允许
        WebsocketClient.addListener('CREATE_ORDER_REQUEST_SUCCESSED', this.orderRequestSuccessListener)
        // $ 审核被拒绝
        WebsocketClient.addListener('CREATE_ORDER_REQUEST_FAILED', this.orderRequestFailListener)
        // $ 监听用户的购物车提交 ，更新轮次规则
        WebsocketClient.addListener('CART_COMMIT_QOP', this.cartCommitListener);
        // $ 监听到其他用户进入房间，发送当前的购物车数据
        WebsocketClient.addListener('MODIFY_DISH', this.modifyDishListener)
        // $ 监听顾客id
        WebsocketClient.addListener('CUSTOMER_ID', this.customerIdListener)
        // $ 消息条
        WebsocketClient.addListener('MESSENGER', this.showMessenger);
         // 菜品超额提醒
        WebsocketClient.addListener('FIRST_EXCESS_WARNING', this.dishExcessListener);

        // !!! $ 监听设备息屏或唤起状态
        // if (PHONE_TYPE.indexOf('iPhone') > -1) {
        // console.log(PHONE_TYPE.indexOf('iPhone'),'PHONE_TYPE')
        document.addEventListener('visibilitychange', this.deviceStatus, false);

        // $ 防止页面后退
        window.history.pushState(null, '', document.URL);
        window.addEventListener('popstate', function () {
            window.history.pushState(null, '', document.URL);
        });
    }

    public async componentDidMount() {
        // 去除购物车的兼容报错字段
        serverShoppingCart.errorKeys = [];
        // 检查桌台状态
        await this.checkTableStatus();
        WebsocketClient.joinOrder(getCacheField('tableId'))
        // 没有桌台id，跳回启动页
        if (!getCacheField('tableId')) {
            createHashHistory().push({ pathname: '/' });
        }
        let settingInfo = await DefaultRequest.getSettingInfo();
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'settingInfo',
            value: settingInfo
        });
        // 更新缓存中的图片加载随机数参数
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'imgRandomNumberParam',
            value: Math.random() * 100000,
        });
        // BMap获取当前位置
        const res = await GMapGetcurrentLocation();
        // this.setState({ disabledOrderBtn: !!res })
        // 是否需要引导模式
        const guide = getSettingInfo('guide', 'value');
        if (guide !== 1) {
            // 引导页是否显示
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'guidePageHideDishes',
                value: false
            });
            // 新手引导-卡片提示
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'guidePageHideCard',
                value: false
            });
            // 新手引导-Door 页面 首选菜单卡片提示
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'guidePageHideHomeCard',
                value: false
            });
            // 新手引导-Door 页面 首选菜单卡片提示 状态2
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'guidePageHideHomeCardTwo',
                value: false
            });
            WebsocketClient.emit('GUIDE_DISH_UPDATE')
        }

        // 初始化轮次菜品规则
        const { autonomous, globalLimitEnable, isOpenPIN } = this.setDishRules();
        this.setState({
            autonomous,
            globalLimitEnable,
            isOpenPIN,
            disabledOrderBtn: !!res,
        }, () => {
            // 审核被拒绝 直接跳回首页
            if (getCacheField('approvalStatus') === 'REJECTED') {
                createHashHistory().push({ pathname: '/Home' });
            }
            // 执行初始化购物车
            this.initCart();
            // 开启轮询倒计时
            this.changeSecond();
        })
    }
    public UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.orderTab) {
            if (nextProps.orderTab.orderId !== this.props.orderTab.orderId) {
                // 审核通过
                this.createOrder()
            }
        }
    }
    public async componentWillUnmount() {
        // window.addEventListener('beforeunload', this.beforeunload);
        // $ alwyas unsubscribe in un mount function
        this.setState = (state, callback) => { return; };
        // $ 监听WS连接
        WebsocketClient.removeListener('CONNECT', this.connectWS);
        WebsocketClient.removeListener('CART_COMMIT_QOP', this.cartCommitListener);
        WebsocketClient.removeListener('CREATE_DISH', this.createDishListener);
        WebsocketClient.removeListener('MODIFY_DISH', this.modifyDishListener);
        WebsocketClient.removeListener('CUSTOMER_ID', this.customerIdListener);
        WebsocketClient.removeListener('CREATE_ORDER_REQUEST_SUCCESSED', this.orderRequestSuccessListener);
        WebsocketClient.removeListener('CREATE_ORDER_REQUEST_FAILED', this.orderRequestFailListener);
        WebsocketClient.removeListener('CONNECT_CART', this.connectCartListener);
        WebsocketClient.removeListener('INIT_CART', this.initCartListener);
        WebsocketClient.removeListener('CART_ERROR', this.cartErrorListener);
        WebsocketClient.removeListener('MARKETING', this.marketingListener);
        WebsocketClient.removeListener('SUBMITING_CART', this.submitngCartListener);
        WebsocketClient.removeListener('CHANGE_CART_TABLE', this.changeCartTableListener);
        WebsocketClient.removeListener('SUBMIT_CART', this.submitListener);
        WebsocketClient.removeListener('MESSENGER', this.showMessenger);
        WebsocketClient.removeListener('FIRST_EXCESS_WARNING', this.dishExcessListener);
        document.removeEventListener('visibilitychange', this.deviceStatus, false);
        if (this.reRenderOrderHistoryTimer) clearTimeout(this.reRenderOrderHistoryTimer);
        clearInterval(time);
        // 清除定时器
        if (this.closeAddedTipsTimeout) {
            clearTimeout(this.closeAddedTipsTimeout)
        }
    }


    // *********************
    // 方法区
    // *********************

    /**
     * 检查桌台状态
     */
    async checkTableStatus() {
        // // 缓存中的桌台状态
        // let resultTableStatus = StateManager.getFromCache('tableStatusById');
        // // select_menu为空时,视为jk开台
        // if (_.isEmpty(resultTableStatus) || _.isEmpty(resultTableStatus?.[0]?.select_menu)) {
        // 根据桌台id获取当前桌台状态
        let resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
        // 当前桌台状态存入缓存
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'tableStatusById',
            value: resultTableStatus,
        })
        // }
        const resultTableInfo: TableStatus | undefined = _.get(resultTableStatus, '0');
        if (resultTableInfo) {
            const cacheOrderID = getCacheField('orderTab.orderId');
            if (cacheOrderID && _.get(resultTableInfo, 'order_head_id') && _.get(resultTableInfo, 'order_head_id') !== cacheOrderID) {
                console.log('订单id不同，重新扫码', `${_.get(resultTableInfo, 'order_head_id')} ===?${cacheOrderID}`)
                this.messengerModule.say({
                    message: `请重新扫码`,
                    level: "Error",
                });
                createHashHistory().push({ pathname: '/' });
                return;
            }
            const TAB_STATUS = (_.get(resultTableStatus, '0.table_status') !== 4) &&
                (_.get(resultTableStatus, '0.table_status') !== 3) && (_.get(resultTableStatus, '0.table_status') !== 2)
            if (TAB_STATUS && getCacheField('approvalStatus') !== 'REVIEW') {
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.orderId',
                    value: _.get(resultTableStatus, '0.order_head_id')
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.person',
                    value: _.get(resultTableStatus, '0.customer_num')
                })
                const FIND_RES = this.getSettingInfoValue('open-table-audit');
                const isApproved = FIND_RES ? FIND_RES.value.enable : true
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'approvalStatus',
                    value: isApproved ? 'REVIEW' : 'NO',
                })

                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderRequestMsg',
                    value: {
                        type: '',
                        tableId: '',
                        menu: {
                            // id
                            main_group_id: 0,
                            // name
                            main_group_name: '',
                        },
                        adultNum: 0,
                        childNum: 0,
                        otherNum: 0,
                        person: 0,
                        customer: '1'
                    }
                })
                createHashHistory().push({ pathname: '/Home' });
                this.messengerModule.say({
                    message: `${i18n.t('menu_page_text_order_does_not_exist')}`,
                    level: "Warning",
                });
            }
            else {
                if (!!_.get(resultTableInfo, 'order_head_id')) {
                    // 由jk开台，没有菜单的情况下不执行下面逻辑
                    if (resultTableInfo.table_status === 4 || resultTableInfo.select_menu === '') return;
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab',
                        value: {
                            person: resultTableInfo.customer_num,
                            orderId: resultTableInfo.order_head_id,
                            menuList: {
                                // id
                                main_group_id: resultTableInfo.select_menu,
                                // name
                                main_group_name: '',
                            },
                            customer: getCacheField('orderTab.customer'),
                            childNum: resultTableInfo.child_number,
                            normalNum: resultTableInfo.adult_number,
                            otherNum: resultTableInfo.other_number,
                        }
                    })
                }
            }
            // 用于区分聚客服务端开的桌台 (无人数)
            if (resultTableStatus[0].cor_status !== 1
                || (resultTableStatus[0].table_status !== 3
                    && (resultTableStatus[0].table_status !== 4)
                    && resultTableStatus[0].table_status !== 2)) {
                // 审核状态
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'approvalStatus',
                    value: 'REVIEW',
                })
            }
        }
        try {
            WebsocketClient.addListener('CREATE_DISH', this.createDishListener);

            Store.dispatch({
                type: 'SET_CACHING',
                path: 'viewPage',
                value: 'menuPage'
            });
            let count = 1;
            const personArr = [];
            const PERSON = getCacheField('orderTab.person');
            const CUSTOMER = getCacheField('orderTab.customer');

            if (PERSON) {
                for (let i = 0; i < PERSON; i++) {
                    personArr.push((count++).toString());
                }
            }
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'personArr',
                value: personArr
            })

            WebsocketClient.emitOrderClients({
                event: 'MODIFY_DISH',
                customer: CUSTOMER,
                dish: Store.getState().shoppingCart
            })
        } catch (error) {
            this.messengerModule.say({
                message: error as string,
                level: 'Warning'
            })
        }
    }

    /**
     * 点餐提示-菜品长度处理
     * @param name 菜品名
     * @param len  最大截取长度
     */
    public byteHandle(name: string, len = 40) {
        let new_playerName = '';
        if (name.length > len) {
            new_playerName = name.substring(0, len);
            new_playerName += '... '
        }
        else {
            new_playerName = name;
        }
        return new_playerName;
    }

    /**
     *  $ 监听通讯事件
     */
    // 监听自己购物车提交
    public cartCommitListener = async (data: CartCommitEventObject) => {
        this.setState({ turnInfo: data.turnInfo })
    }
    // 监听用户扫码进入后,同步购物车数据
    public createDishListener = (data: CreateDishEventObject) => {
        ShoppingCart.metaData = data.dish;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'shoppingCart',
            value: data.dish
        })
    }
    // 监听服务端发送的审核允许通知
    public orderRequestSuccessListener = async (data: CreateOrderRequestSuccessedEventObject) => {
        if (data.orderId) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.orderId',
                value: data.orderId
            })
            const cartHistory = await DefaultRequest.getHistoryDish(
                data.orderId,
                Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9,
                'round,dish,type,rule'
            )
            // 更新自主点餐模式
            ShoppingCart.historyDishNumMetaData = cartHistory.dish_round_customer_data;
            ShoppingCart.historyDishRulesMetaData = cartHistory.dishRuleData;
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'roundCustomerDishData',
                value: cartHistory.round_customer_dish_data
            })
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'approvalStatus',
                value: 'APPROVED'
            })

            // $  重新初始化连接购物车（购物车id、orderId）
            this.initCart();
        }
    }
    // 监听服务端发送审核拒接通知
    public orderRequestFailListener = (data: CreateOrderRequestFailedEventObject) => {
        this.messengerModule.say({
            message: `${i18n.t('menu_page_text_review_rejected')}`,
            level: "Error",
        });
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'approvalStatus',
            value: 'REJECTED'
        })
        const orderTab = Store.getState().orderTab;
        console.log(orderTab);
        orderTab.menuList = {
            main_group_id: 0,
            main_group_name: ''
        }
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderTab',
            value: orderTab,
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'isOpenTab',
            value: false,
        })
        createHashHistory().push({ pathname: '/Home' });
    }
    // 监听用户id是否冲突
    public customerIdListener = (data: CustomerIdEventObject) => {
        // id被占用
        if (data.customer === StateManager.getFromCache('orderTab.customer')) {
            this.messengerModule.say({
                message: `${i18n.t('menu_page_text_customer_id_occupy')}`,
                level: "Error",
            });
            WebsocketClient.leaveOrder()
            createHashHistory().push({ pathname: `/?table_id=${getCacheField('tableId')}` });
        }
    }

    // todo 分析此方法 监听用户加入房间和菜品的修改
    public modifyDishListener = (data: DishModifyEventObject) => {
        console.log(`用户：${data.customer}加入房间。`);

        // $ 当前购物车内没有该顾客的购物车，应初始化顾客对应的购物车
        // 检查轮次是否存在
        // if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, {});
        // // 检查顾客是否存在
        // if (data.customer && !_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${data.customer}`)) {
        //     _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${data.customer}`, []);
        // }

        WebsocketClient.emitOrderClients({
            event: 'CREATE_DISH',
            customer: data.customer || '1',
            dish: ShoppingCart.metaData
        })
        // $ 如果在轮次倒计时大于5秒，就发送 轮次时间的显示状态
        const second = Store.getState().roundTime;
        // 设置倒计时最后5秒区间不能操作，为防止用户操作菜品导致轮次信息不一致
        if (second > 5) {

            WebsocketClient.emitOrderClients({
                event: 'FIRST_JOIN',
                customer: data.customer || '1',
                dish: ShoppingCart.metaData,
                round: ShoppingCart.globalRound,
                isShowTime: getCacheField('isShowTime')
            })
        } else {
            WebsocketClient.emitOrderClients({
                event: 'FIRST_JOIN',
                customer: data.customer || '1',
                dish: ShoppingCart.metaData,
                round: ShoppingCart.globalRound,
            })
        }

        // $ 往新进入的顾客发送桌台状态
        // console.log('往新进入的顾客发送桌台状态', getCacheField('orderRequestMsg'));
        WebsocketClient.emitOrderClients({
            event: 'TABLE_STATUS',
            customer: data.customer || '1',
            orderRequestMsg: getCacheField('orderRequestMsg'),
            isOpenTab: getCacheField('isOpenTab'),
            resendOrderSecond: getCacheField('resendOrderSecond'),
            orderTab: getCacheField('orderTab'),
        })

    }


    /**
     * 连接WS
     */
    public connectWS = () => {
        // $  重新初始化连接购物车（购物车id、orderId）
        console.log('断网重连，初始化购物车')
        this.initCart();
    }

    /**
     * 断开连接WS
     */
    public disConnectWS = () => {
    }

    /**
     * showMessenger
     */
    public showMessenger = (data: { message: string, level: string }) => {
        try {
            this.messengerModule.say({
                message: data.message,
                level: data.level || "Warning",
            });
        } catch (error) { }
    }


    /**
     * 服务端购物车 - 监听连接购物车
     * @param data
     */
    public connectCartListener = (data: ConnectCart) => {
        console.log(data, '监听 连接购物车---CONNECT_CART');
        ServerShoppingCart.updateSeverShoppingCartModule(data.data, true);
        this.isInitCart = false;
    }


    /**
     * 服务端购物车 - 监听初始化购物车
     * @param data
     */
    public initCartListener = (data: InitCart) => {
        console.log(data, '监听 初始化购物车---INIT_CART');
        ServerShoppingCart.updateSeverShoppingCartModule(data.data, true);
        if (data) {
            let user;
            let customer = getCacheField('orderTab.customer');
            console.log(customer, ' - customer');
            if (data.data && customer) {
                user = _.find(data.data?.users, (n) => n.userName === customer);
                // $ 连接购物车
                ServerShoppingCart.connetSeverShoppingCart({
                    cartFind: {
                        id: data.data.id,
                        orderId: `${getCacheField('orderTab.orderId')}`,
                    },
                    user,
                })
            }
        }
    }

    /**
     * 服务端购物车 - 错误提示
     * @param data
     */
    public cartErrorListener = (data: CartError) => {
        const error = CART_MODULE_ERRORS.find((item) => item.error === data.message);
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'cartButtonLoading',
            value: false,
        })
        let isIgnoreTransI18N: boolean = false;
        if (error) {
            if (error.error === 'R3: Excessed the max quantity in per turn.') {
                // ! 弹出你已完成本轮点餐，但是改轮次才刚开始, 然后进入下一轮
                const dishesData = ServerShoppingCart.getCurrentCustomerCart({}) as any;
                let historyDishes = dishesData?.r3HistoryDishes as Cart2.Item[];
                const autoOrder = getSettingInfo('rule-autonomous-meal', 'value') || { status: false };
                if (autoOrder.status) {
                    const newDishesData = ServerShoppingCart.getCurrentCustomerCart({ all: true });
                    if (newDishesData) {
                        const { r3HistoryDishes } = newDishesData;
                        historyDishes = r3HistoryDishes as Cart2.Item[];
                    }
                }
                // console.log(serverShoppingCart.metaData?.r3?.r3MaxDishPerTurn, 'serverShoppingCart.metaData?.r3?.r3MaxDishPerTurn')
                // 要排除点满进入倒计时中，进行点餐时出现该提示，属于正常，不用发送
                // 查找当前轮次在历史记录是否存在数据，并且已点满
                const curTurnInHisNums = (historyDishes as Cart2.Item[]).reduce((pre, cur) => {
                    const currentTurn = ServerShoppingCart.metaData?.r3?.nowTurn;
                    cur.turn === currentTurn && (pre += cur.totalNum);
                    return pre;
                }, 0);
                const maxOrderCount = ServerShoppingCart.metaData?.r3?.r3MaxDishPerTurn as number;
                // console.log(curTurnInHisNums, 'curTurnInHisNums',maxOrderCount,autoOrder);
                const isHistoryFull = curTurnInHisNums >= ((autoOrder as any)?.status ? maxOrderCount * this.props.orderTab?.person : maxOrderCount);
                console.log(dishesData?.dishes, 'cartErrorListener', ServerShoppingCart.isToNextTurn, 'isHistoryFull', isHistoryFull)
                if ((!dishesData.dishes.length || isHistoryFull) && ServerShoppingCart.isToNextTurn && !serverShoppingCart.disableToNext) {
                    // 是否进入下一轮次
                    // (_.debounce(() => {
                        console.log('手动推进轮次一次', serverShoppingCart.disableToNext)
                        serverShoppingCart.disableToNext = true;
                        serverShoppingCart.toNextTurnManually({});
                    // }, 300))()
                    return;
                }
            }
            let _errorMessage: string = error.message;
            // 沽清菜品校验错误,提交购物车失败
            if (data.message === 'R1: Excessed the max sell quantity.' && !_.isEmpty(_.get(data, 'detail.outOfStock'))) {
                const dataOutStocks = _.get(data, 'detail.outOfStock');
                if (Array.isArray(dataOutStocks) && dataOutStocks.length > 0) {
                    let errorMsg: string = `${i18n.t('order_cart_page_text_commit_cart_fail')}: `;
                    for(const eItem of dataOutStocks) {
                        errorMsg += i18n.t('order_cart_Page_text_verify_sold_out_dishes_message',{
                            menuName: eItem.menuName,
                            excessedNum: eItem.excessedNum,
                        })    
                    }
                    _errorMessage = errorMsg;
                    isIgnoreTransI18N = true;
                }
            }
            this.messengerModule.say({
                message: _errorMessage,
                level: 'Warning',
                isIgnoreTransI18N: isIgnoreTransI18N,
            })
        }
        // 购物车不存在
        if (data.message === 'Cart not found.') {
            this.initCart();
        }
        // 若因某些参数失败，则重新发送一次
        const invalidKey = _.get(data, 'detail[0].params.additionalProperty');
        if (invalidKey) {
            const { errorKeys, cartParam } = serverShoppingCart;
            !errorKeys.includes(invalidKey) && serverShoppingCart.errorKeys.push(invalidKey);
            serverShoppingCart.updateServerCart({...cartParam});
            return;
        }
        // R8限点限制，控制限点数量区域动画
        if (data.message === 'R8: Excessed the max quantity.') {
            this.menuPageRef?.onControlLimitNumsAnimate(true);
        }
    }

    /**
     * 服务端购物车 - 监听校验营销规则
     */
    public marketingListener = (data: Marketing) => {
        // $ 优化：限定2秒区间内，他人点餐提示只能触发一遍
        this.checkMarketing(data);
    }

    /**
     * 服务端购物车 - 校验营销规则
     * @param data
     */
    public checkMarketing = _.throttle(function (data: Marketing) {
        // 营销规则校验结果
        const { status, marketing, m2ItemNum, m1CustomerNum } = data.data;
        // 菜品信息
        const menuItem: Cart2.Item = _.get(data, 'parameter.itemTarget.menuItem', {}) || {};
        // 用户是否点击了不再提示
        const isShow = getCacheField('addedTipsStatus');
        // 触发
        if (status && isShow) {
            // 菜品名称显示
            const name = this.isShowName1 ? menuItem.name : menuItem.name2 || '';
            // 菜品名称长度处理
            const showName = this.byteHandle(name);
            // 消息提示
            let dishesMsg = '';
            // m1是指点该菜的人数占总人数的比值大于等于x时
            if (marketing === 'M1' as Cart2.Marketing) {
                // 已有{{n}}人点了{{dish}}
                dishesMsg = i18n.t('menu_page_text_more_than_half_ordered', {
                    n: m1CustomerNum,
                    dish: showName
                })
            }
            // m2是指定菜品数量占所有菜品数量比值超过x时
            else {
                // {{n}}在本轮被点了{{1}}份
                dishesMsg = i18n.t('menu_page_text_dishes_copy', {
                    1: m2ItemNum,
                    n: showName
                })
            }
            // 显示提示窗
            this.setState({
                dishesName: dishesMsg,
                addedTips: true
            }, () => {
                // 清除定时器
                if (this.closeAddedTipsTimeout) {
                    clearTimeout(this.closeAddedTipsTimeout)
                }
                // 3s后自动关闭
                this.closeAddedTipsTimeout = setTimeout(() => {
                    this.setState({
                        addedTips: false
                    })
                }, 3000)
            })
        }
    }, 5000, {
        leading: true,
        trailing: true
    })

    /**
     * 服务端购物车 - 提交购物车中
     */
    public submitngCartListener = () => {
        this.messengerModule.say({
            message: `${i18n.t('order_cart_page_text_is_submitting')}`,
            level: 'Warning'
        })
    }
    /**
     * 服务端购物车 - 提交购物车成功
     */
    public submitListener = async (data: SubmitCart) => {
        // 服务端记录轮次倒计时
        console.log(data, '监听 提交购物车-main.page--SUBMIT_CART');
        const curTurnInfo = await ServerShoppingCart.getOrderTurn();
        this.floatingWinsRef?.initTrunInfoSSC?.(curTurnInfo);
        if (data.project === 'QOP_COP') {
            if (data.toNextTurn) {
                console.log('1');

                ServerShoppingCart.toNextTurn({});
                // 提交购物车成功之后,更新轮次,倒计时
                await this.getOrderTurnSSC();
            }
            ServerShoppingCart.updateSeverShoppingCartModule(data.data, true);
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'cartButtonLoading',
                value: false,
            })
        }
        // 提交完成通知浮窗更新
        ServerShoppingCart.isToNextTurn = false;
    }

    /**
     * 服务端购物车 - 提交完购物车重新获取轮次规则
     * @returns
     */
    public async getOrderTurnSSC() {

        try {
            let customer = getCacheField('orderTab.customer');
            // 轮次规则
            let turnInfo = await DefaultRequest.getTurnInfo(
                getCacheField('orderTab.orderId'),
                Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9
            );

            if (Array.isArray(turnInfo)) {
                this.messengerModule.say({
                    message: `${i18n.t('general_text_get_limit_rule_failed')}`,
                    level: 'Warning',
                });
                return;
            }
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'turnInfo',
                value: turnInfo
            })
            // $ 提交购物车后更新对方设备的轮次规则
            // 在自助点餐更新自己的数量，非自助点餐同时更新其他设备
            WebsocketClient.emitOrderClients({
                event: 'CART_COMMIT_OTHER',
                turnInfo: turnInfo,
                customer
            })
            WebsocketClient.emit('CART_COMMIT_QOP', {
                event: 'CART_COMMIT_QOP',
                turnInfo: turnInfo,
                customer
            })
        } catch (error) {
            this.messengerModule.say({
                message: error as string,
                level: 'Error'
            })
        }
    }

    /**
     * 服务端购物车 - 转台通知
     */
    public changeCartTableListener = async (data: UpdateCart) => {
        console.log('转台通知', data)
        ServerShoppingCart.updateSeverShoppingCartModule(data.data, true);
        await this.matchTableOrderInfo();
    }


    /**
     * 监听设备状态
     */
    public async deviceStatus() {
        if (ShoppingCart.condimentModel) return;
        if (document.hidden) {
            // 页面被挂起
            // console.log(`页面/设备${Store.getState().orderTab.customer} 被挂起`);
            WebsocketClient.leaveOrder();
            WebsocketClient.disconnect();
        }
        else {
            // 获取服务器与本地时间戳差值
            const diffTimeStamp = await getSeverAndLoacalDiff();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'diffTimeStamp',
                value: diffTimeStamp,
            })
            // 强制刷新页面
            window.location.reload();
            // 重新初始化客户端
            WebsocketClient.init();
            // 重新连接房间
            WebsocketClient.connect();
            WebsocketClient.joinOrder(getCacheField('tableId'));
            // alert('重新连接房间')
            // 页面呼出
            // console.log(`页面/设备${Store.getState().orderTab.customer} 呼出`);
        }
    }

    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    /**
     * 初始化轮次菜品规则
     */
    public setDishRules() {
        // 获取点餐模式
        const AUTONOMUS = getSettingInfo('rule-autonomous-meal', 'value');
        // 获取规则
        const GLOBAL_LIMIT = getSettingInfo('rule-global-turn-limit', 'value');
        // 一轮一提交规则
        // const ONE_ROUND_SUBMIE_RULE = getSettingInfo('one_turn_one_time_send', 'value');
        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2');
        // 是否开启临时密码功能
        const ISOPEN_PIN = getSettingInfo('order_head_password', 'value');
        if (findRes) this.isShowName1 = findRes.value.showItemName1
        // this.setState({
        //     autonomous: AUTONOMUS,
        //     globalLimitEnable: GLOBAL_LIMIT ? GLOBAL_LIMIT.enable : true,
        //     isOpenPIN: ISOPEN_PIN ? ISOPEN_PIN : 0
        // }, () => {
        //     // ShoppingCart.GLOBAL_SELF_ORDER_RULE = AUTONOMUS && AUTONOMUS.status;
        //     // ShoppingCart.GLOBAL_ROUND_LIMIT_RULE = this.state.globalLimitEnable;
        //     // ShoppingCart.ONE_ROUND_SUBMIE_RULE = ONE_ROUND_SUBMIE_RULE || 0
        //     // 服务端购物车
        //     ServerShoppingCart.GLOBAL_SELF_ORDER_RULE = AUTONOMUS && AUTONOMUS.status;
        //     ServerShoppingCart.GLOBAL_LIMIT = GLOBAL_LIMIT?.enable || false;
        // })
        ServerShoppingCart.GLOBAL_SELF_ORDER_RULE = AUTONOMUS && AUTONOMUS.status;
        ServerShoppingCart.GLOBAL_LIMIT = GLOBAL_LIMIT?.enable || false;
        return {
            autonomous: AUTONOMUS,
            globalLimitEnable: GLOBAL_LIMIT ? GLOBAL_LIMIT.enable : true,
            isOpenPIN: ISOPEN_PIN ? ISOPEN_PIN : 0
        }
    }
    // $ 菜品添加提示弹窗
    public addedTipsHandleChange = (event: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
        this.setState({ isTipsChecked: event.target.checked })
    };

    /**
     * 执行初始化购物车
     */
    public initCart() {
        if (this.isInitCart || this.props.approvalStatus === 'REVIEW') return;
        this.isInitCart = true;
        // $ 初始化购物车metaData
        ServerShoppingCart.updateSeverShoppingCartModule(undefined);
        // $ 初始化购物车过滤器
        WebsocketClient.initCartFilter({});
        // $ 初始化购物车
        if (getCacheField('orderTab.orderId') !== 0) {
            console.log(getCacheField('orderTab.orderId'), 'orderTab.orderId');
            WebsocketClient.initServerCart({
                cartFind: {
                    // id: '',
                    orderId: `${getCacheField('orderTab.orderId')}`,
                    tableId: `${getCacheField('tableId')}`
                },
                customerNum: Number(getCacheField('orderTab.person')),
            });
        }
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'cartButtonLoading',
            value: false,
        })
    }

    // *********************
    // 方法区
    // *********************

    /**
     * update local state by object
     * @param val
     */
    public updateLocalState = (val: any) => {
        this.setState(val);
    }
    /**
     * 切换视图层
     */
    public renderPage = (turnInfo: TurnInfo) => {
        try {
            const { approvalStatus, resendOrderSecond, orderTab } = this.props;
            const { customer } = orderTab;
            switch (Store.getState().viewPage) {
                case 'menuPage':
                    return <MenuPage
                        ref={(ref: any) => this.menuPageRef = ref}
                        customer={customer}
                        resendOrderSecond={resendOrderSecond}
                        approvalStatus={approvalStatus}
                        updateLocalState={this.updateLocalState}
                    />;
                case 'orderHistory':
                    let isInterfaceSwitch = getCacheField('isInterfaceSwitch');
                    return <OrderHistory
                        ref={(ref: any) => this.orderHistoryRef = ref}
                        isInterfaceSwitch={isInterfaceSwitch}
                    />;
                // case 'shoppingCartPage':
                //     return <OrderCart
                //         turnInfo={turnInfo}
                //         updateLocalState={this.updateLocalState}
                //         approvalStatus={approvalStatus}
                //     />;
                case 'noticePage':
                    return <NoticePage />;
                case 'homePage':
                    return <HomePage />;
                case 'callWaiter':
                    return <CallWaiter />
                default:
                    // For Dev
                    return <MenuPage
                        ref={(ref: any) => this.menuPageRef = ref}
                        customer={customer}
                        resendOrderSecond={resendOrderSecond}
                        approvalStatus={approvalStatus}
                        updateLocalState={this.updateLocalState}
                    />;

            }
        } catch (error) {
            this.messengerModule.say({
                message: error as string,
                level: "Warning",
            })
        }
    }

    /**
     * 创建订单
     *
     */
    createOrder = async () => {
        const ORDERID = getCacheField('orderTab.orderId');

        // 获取自动生成的客户名称
        const autonomous = getSettingInfo('rule-autonomous-meal', 'value');
        if (autonomous && autonomous.status) {
            // 如果顾客不存在的情况下,才触发客户名称的自动生成
            if (!getCacheField('orderTab.customer')) this.getGenerateCustomerName(ORDERID)
        }
        // 轮次规则
        let turnInfo = await DefaultRequest.getTurnInfo(
            ORDERID,
            Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9
        );
        if (Array.isArray(turnInfo)) {
            this.messengerModule.say({
                message: `${i18n.t('general_text_get_limit_rule_failed')}`,
                level: "Warning",
            });
            return;
        }
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'turnInfo',
            value: turnInfo,
        });
    }

    /**
     * 获取自动生成的客户名称
     */
    public async getGenerateCustomerName(orderId: number) {

        try {
            let result = await DefaultRequest.getGenerateCustomerName(orderId)
            let customer = result.now_customer_name ? result.now_customer_name.toString() : ''
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.customer',
                value: customer
            })
        }
        catch (error) {
            // console.log(error)
        }
    }

    public getCacheGuide(): boolean {
        let bool = StateManager.getFromCache('guidePageHideDishes') || StateManager.getFromCache('guidePageHideCard')
        return bool;
    }

    // 开启轮询倒计时
    public changeSecond = () => {
        if (time) {
            clearInterval(time)
        }
        time = setInterval(
            async () => {
                await this.matchTableOrderInfo();
            }, 30000)
    }
    /**
     * 匹配桌台订单信息
     */
    async matchTableOrderInfo() {

        // 获取到订单详情
        let orderDetail: OrderInfo | false = await DefaultRequest.getOrderDetail(
            getCacheField('orderTab.orderId'), getSettingInfo('package-fee', 'value').menu_id
        );

        // 判断的此订单是否存在
        if (orderDetail && _.has(orderDetail, 'table_id')) {
            // 如果获取的订单桌台数据跟缓存不一致，说明转台，需要改变当前订单的桌台信息
            const orderRequestMsg = Store.getState().orderRequestMsg;
            let TABLE_NAME = getCacheField('tableName');
            let TABLE_ID = getCacheField('tableId');
            // 如果获取的订单桌台数据跟缓存不一致，说明转台，需要改变当前订单的桌台信息
            if (orderDetail.table_id !== TABLE_ID) {
                if (
                    TABLE_ID === orderDetail.table_id &&
                    TABLE_NAME === orderDetail.table_name
                ) return;
                _.set(orderRequestMsg, 'tableId', orderDetail.table_id);
                // 更新订单数据
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderRequestMsg',
                    value: orderRequestMsg
                });
                // 桌台id
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableId',
                    value: orderDetail.table_id,
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableName',
                    value: orderDetail.table_name
                })
                // 更新浮窗的桌台信息
                WebsocketClient.emit('UPDATE_ORDER_TABLE');
                // $ 转台重新连接购物车（购物车id、orderId）
                let customer = getCacheField('orderTab.customer');
                if (customer) {
                    let metaData = ServerShoppingCart.metaData;
                    let user = _.find(metaData?.users, (n) => n.userName === customer);
                    // 连接购物车
                    ServerShoppingCart.connetSeverShoppingCart({
                        cartFind: {
                            id: metaData?.id,
                            orderId: `${getCacheField('orderTab.orderId')}`,
                            tableId: undefined
                        },
                        user,
                    })
                }
            }
        } else {
            let resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
            if (_.get(resultTableStatus, '0')) {
                if (_.get(resultTableStatus, '0.order_head_id')) {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.orderId',
                        value: _.get(resultTableStatus, '0.order_head_id')
                    })
                }
                const TAB_STATUS = (_.get(resultTableStatus, '0.table_status') !== 3)
                    && (_.get(resultTableStatus, '0.table_status') !== 2)
                    && (_.get(resultTableStatus, '0.table_status') !== 4);
                if (TAB_STATUS && getCacheField('approvalStatus') !== 'REVIEW') {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.orderId',
                        value: _.get(resultTableStatus, '0.order_head_id')
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'approvalStatus',
                        value: 'REVIEW',
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg',
                        value: {
                            type: '',
                            tableId: '',
                            menu: {
                                // id
                                main_group_id: 0,
                                // name
                                main_group_name: '',
                            },
                            adultNum: 0,
                            childNum: 0,
                            otherNum: 0,
                            person: 0,
                            customer: '1'
                        }
                    })
                    // 订单结账或关台 需要重置本地缓存的临时密码
                    addCookie('orderCode', '', 3600);
                    addCookie('orderId', 0, 3600);
                    createHashHistory().push({ pathname: '/Home' });
                    this.messengerModule.say({
                        message: `${i18n.t('menu_page_text_order_does_not_exist')}`,
                        level: "Warning",
                    });
                }
            }


        }
    }

    /**
     * 控制购物车抽屉弹窗
     * @param flag 
     */
    onSetCartDrawer = (flag: boolean) => {
        if (!flag) {
            const viewPage = StateManager.getFromCache('viewPage');
            if (viewPage === 'orderHistory' && this.orderHistoryRef) {
                if (this.reRenderOrderHistoryTimer) clearTimeout(this.reRenderOrderHistoryTimer);
                this.reRenderOrderHistoryTimer = setTimeout(async () => {
                    await this.orderHistoryRef?.getOrders();
                }, 1000)
            }
        }
        this.setState({
            isOpenCartDrawer: flag
        })
    }

    // 菜品超额提醒
    public dishExcessListener = (data: ExcessTip) => {
        if (data.type === WSClientEventName.FIRST_EXCESS_WARNING) {
            data?.isAddedToCart &&
                this.setState({
                    isShowDishExcessDialog: true
                })
        }
    }

    /**
     * 超额菜品提示
     */
    public renderExecCartModalctl() {
        return (
            <Dialog
                className="checkCommitDialog excessDialog"
                open={this.state.isShowDishExcessDialog}
                onClose={() => { this.setState({ isShowDishExcessDialog: false }) }}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{i18n.t('menu_page_text_dish_exceeded')}</DialogTitle>
                <DialogActions>
                    <Button fullWidth variant="contained" onClick={() => { this.setState({ isShowDishExcessDialog: false }) }} color="primary">
                        {i18n.t('general_button_cancel')}
                    </Button>
                    <Button fullWidth variant="contained"
                        onClick={async() => {
                            const { cartParam } = serverShoppingCart;
                            await serverShoppingCart.updateServerCart({...cartParam, isAddedToCart: true});
                            this.setState({ isShowDishExcessDialog: false })
                        }}
                        color="primary">
                        {i18n.t('general_button_sure')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { addedTips, isTipsChecked, dishesName, turnInfo, globalLimitEnable, isOpenPIN, disabledOrderBtn
        } = this.state;
        const viewPage = StateManager.getFromCache('viewPage');
        return (
            <div
                id="mainPage"
                className='overall-center main-page'
                style={{ width: '100%', position: 'fixed', overflow: 'hidden', touchAction: 'none' }}
            >
                {/* 不在餐厅区域显示蒙层 */}
                {disabledOrderBtn &&
                    <div className='not-in-the-area-mask-box'>
                        <div className='not-in-the-area-mask-box-content'>
                            {i18n.t('general_text_You_are_not_in_the_restaurant_area_unable_to_order')}
                        </div>
                    </div>
                }
                {/* 如果开桌密码为空 ||  */}
                {/* 订单加密确认框 */}
                {
                    !!isOpenPIN &&
                    <EncryptModal
                        orderTab={this.props.orderTab}
                        approvalStatus={this.props.approvalStatus}
                        updateLocalState={this.updateLocalState}
                    />
                }
                {/* 引导页遮罩 */}
                {
                    this.getCacheGuide() && <div className='guide-page-mask' onClick={() => {
                        this.count += 1;
                        setTimeout(() => {
                            if (this.count === 1) {
                                // 单击触发
                                Store.dispatch({
                                    type: 'SET_CACHING',
                                    path: 'guidePageHideDishes',
                                    value: false,
                                })
                                addCookie('guidePageHideDishes', false, 3600000);
                                if (this.state.guidehideCardStatus) {
                                    Store.dispatch({
                                        type: 'SET_CACHING',
                                        path: 'guidePageHideCard',
                                        value: false,
                                    })
                                    addCookie('guidePageHideCard', false, 3600000);
                                    // Store.dispatch({
                                    //     type: 'SET_CACHING',
                                    //     path: 'hideGuide',
                                    //     value: false,
                                    // })
                                }
                                WebsocketClient.emit('GUIDE_DISH_UPDATE')
                                // 更新新手指引点击状态
                                this.setState({ guidehideCardStatus: true });
                            } else if (this.count === 2) {
                                // 双击触发
                            }
                            this.count = 0;
                        }, 200);
                    }}></div>
                }
                {/* 营业时间通知框 */}
                <DisableDish />
                {/* Dishes added tips */}
                <div className={addedTips ? 'otherCustomersModal modaloffSet' : 'otherCustomersModal'} >
                    <div className='otherCustomersModal_dishesMsg'>{i18n.t(dishesName)}</div>
                    <div className='otherCustomersModal_controls'>
                        <div className='tipsCheckbox'>
                            {/* Checkbox */}
                            <Checkbox
                                style={{ padding: 0, paddingRight: 10 }}
                                checkedIcon={<span className='addTipsCheckIcon' />}
                                icon={<span className='addTipsIcon' />}
                                checked={isTipsChecked}
                                onChange={this.addedTipsHandleChange} />
                            {i18n.t('menu_page_text_not_show')}
                        </div>
                        <div>
                            <Button onClick={() => {
                                console.log("isTipsChecked", isTipsChecked);
                                if (isTipsChecked) {
                                    Store.dispatch({
                                        type: 'SET_CACHING_AND_STATE',
                                        path: 'addedTipsStatus',
                                        value: false,
                                    })
                                }
                                this.setState({ addedTips: false })
                            }}>{i18n.t('general_button_close')}</Button>
                        </div>
                    </div>
                </div>
                {/* 主题内容 */}
                <div className='overall-center'>
                    {
                        this.renderPage(turnInfo)
                    }
                </div>

                {
                    <Floating
                        ref={(refs: any) => { this.floatingWinsRef = refs }}
                        globalLimitEnable={globalLimitEnable}
                        turnInfo={turnInfo}
                        customer={getCacheField('orderTab.customer') || '1'}
                    />
                }
                {
                    <Drawer
                        open={this.state.isOpenCartDrawer}
                        anchor={'bottom'}
                        onClose={() => this.setState({ isOpenCartDrawer: false })}
                    >
                        <OrderCart
                            turnInfo={turnInfo}
                            updateLocalState={this.updateLocalState}
                            approvalStatus={this.props.approvalStatus}
                            onSetCartDrawer={this.onSetCartDrawer}
                        />
                    </Drawer>
                }
                {
                    viewPage !== 'shoppingCartPage' && <Footer
                        customer={this.props.orderTab.customer}
                        foodBarMode={this.props.foodBarMode}
                        approvalStatus={this.props.approvalStatus || 'APPROVED'}
                        onSetCartDrawer={this.onSetCartDrawer}
                    />
                }

                {
                    this.renderExecCartModalctl()
                }
            </div >
        );
    }

}

export default withSnackbar(Main)

// *********************
// Types
// *********************

type State = {
    addedTips: boolean;
    isTipsChecked: boolean;
    dishesName: string;
    cartData: Array<{
        _origin: MenuDish
        count: number;
        price: number;
        totalPrice: number;
        // excess
        excessCount: number;
        excessPrice: number;
        excessTotalPrice: number;
        // condiment
        condiments: Array<MinimizeCondiment>;
        condimentsTotalPrice: number;
        // for view fields
        excessPriceAndCondimentsPriceForView: string;
    }>
    // 已点数量
    turnCount: number
    // 自主点餐是否开启
    autonomous: {
        status: boolean
    }
    // 轮次规则限制是否开启
    globalLimitEnable: boolean,
    turnInfo: TurnInfo
    // 开桌审核状态
    isApproved: boolean;
    // 新手引导显示状态2
    guidehideCardStatus: boolean;
    // 是否开启临时密码 (0关 | 1开)
    isOpenPIN: 0 | 1;
    // 禁止点餐（不在餐厅区域）
    disabledOrderBtn: boolean;
    // 是否开启购物车抽屉
    isOpenCartDrawer: boolean;
    // 展示超额菜品提示
    isShowDishExcessDialog: boolean;
}

type Props = {
    viewPage: 'menuPage' |
    'homePage' |
    'shoppingCartPage' |
    'orderHistory' |
    'adPage' |
    'callWaiter';
    // 底部导航栏模式
    foodBarMode: 'MULTIPLE' | 'SINGLE',
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED',
    // 倒计时
    resendOrderSecond: number,
    // 订单信息
    orderTab: {
        // 开台人数
        person: number;
        // 订单Id
        orderId: number;
        // 菜单信息
        menuList: {
            // id
            main_group_id: number,
            // name
            main_group_name: string,
        };
        // 扫码id
        customer: string;
        // 开台具体人数
        childNum: number,
        normalNum: number,
        otherNum: number,
    }
} & WithSnackbarProps
